import { SETTING_DEFS } from "@gaole/shared";
import { useSettingsDraft } from "../../hooks/useSettingsDraft";
import { GROUP_LABELS } from "../../config/admin-settings";
import { Button, PageLoader, SettingsCard } from "../../components/ui";
import { FlexxiSettingsEditor } from "../settings/FlexxiSettingsEditor";
import { SettingField } from "../Settings";
import { ADMIN_HUB_PAGE } from "../../components/shell/adminHubPage";

type CommerceSettingsTab = "marketplace" | "flexxi";

export function CommerceSettings({ tab }: { tab: CommerceSettingsTab }) {
  const { draft, setValue, saveMut, settings: data, showLoader } = useSettingsDraft();

  if (showLoader) return <PageLoader />;

  if (tab === "flexxi") {
    return (
      <div className={ADMIN_HUB_PAGE}>
        <FlexxiSettingsEditor draft={draft} setValue={setValue} saveMut={saveMut} />
      </div>
    );
  }

  const activeGroups = ["marketplace"];

  return (
    <div className={ADMIN_HUB_PAGE}>
      <div>
        <h1 className="font-display text-lg font-bold">Marketplace settings</h1>
        <p className="mt-0.5 text-xs text-muted">Fees, KYC, moderation, and buyer confirmation.</p>
      </div>
      {activeGroups.map((groupKey) => {
        const defs = SETTING_DEFS.filter((d) => d.group === groupKey);
        const keys = defs.map((d) => d.key);
        return (
          <SettingsCard
            key={groupKey}
            title={GROUP_LABELS[groupKey] ?? groupKey}
            footer={
              <div className="flex justify-end">
                <Button size="sm" disabled={saveMut.isPending} onClick={() => saveMut.mutate(keys)}>
                  Save
                </Button>
              </div>
            }
          >
            <div className="space-y-4">
              {defs.map((def) => {
                const row = (data ?? []).find((s) => s.key === def.key) ?? {
                  ...def,
                  value: draft[def.key] ?? def.defaultValue,
                };
                return (
                  <SettingField
                    key={def.key}
                    row={row}
                    value={draft[def.key] ?? row.value}
                    onChange={(v) => setValue(def.key, v)}
                  />
                );
              })}
            </div>
          </SettingsCard>
        );
      })}
    </div>
  );
}
